module.exports = __webpack_public_path__ + "img/give.c544d91e.png";